import { render, staticRenderFns } from "./ShowDialogSliderBienvenidos.vue?vue&type=template&id=e83f634c&scoped=true"
import script from "./ShowDialogSliderBienvenidos.vue?vue&type=script&lang=js"
export * from "./ShowDialogSliderBienvenidos.vue?vue&type=script&lang=js"
import style0 from "./ShowDialogSliderBienvenidos.vue?vue&type=style&index=0&id=e83f634c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83f634c",
  null
  
)

export default component.exports